import axios from "axios";
import { useEffect, useState } from "react";
import { ValidItem } from "../types/inspect";
import useCustomNavigate from "hooks/common/useCustomNavigate";

export const useInspectList = () => {
  const [items, setItems] = useState<ValidItem[]>([]);
  const { navigateToReplacePath } = useCustomNavigate();

  useEffect(() => {
    handleFetechList();
  }, []);

  const handleFetechList = async () => {
    try {
      const response = await axios.get<ValidItem[]>(
        `${process.env.REACT_APP_BASE_URL}/valid/list`
      );

      setItems(response.data);
    } catch (e) {}
  };

  const handleRouteInspect = (validItem: ValidItem) => {
    navigateToReplacePath(`/inspect/${validItem.id}`);
  };

  return {
    items,
    handleRouteInspect,
  };
};
